import styled from "styled-components";

export const StyledContactCardsContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
    max-width: 604px;
    margin-bottom: 12px;
`;
